// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 767px) {
  ::ng-deep .custom-size-menu.mat-mdc-menu-panel {
    max-width: none !important;
  }

  ::ng-deep .custom-size-menu .mat-mdc-menu-item .mdc-list-item__primary-text {
    font-size: var(--menu-font-size, 36px) !important;
    line-height: normal !important;
  }

  ::ng-deep .custom-size-menu .mat-mdc-menu-item .custom-icon-style {
    font-size: var(--menu-icon-size, 34px) !important;
    width: var(--menu-icon-size, 34px) !important;
    height: var(--menu-icon-size, 34px) !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
  }

  ::ng-deep .custom-size-menu .mat-mdc-menu-item {
    height: auto !important;
    min-height: 64px !important; 
    padding: 12px 24px !important;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
